<template>
<div class="page page_xianli">
	<div class="content">
		<div class="publish_wrap">
			<div class="item">
				<div class="upload-images">
					<div class="img-box" v-for="(item, index) in imglist" :key="index">
						<div class="icon-po">
							<van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
						</div>
						<div class="del" @click="imgDel(index)"></div>
					</div>
					<van-uploader v-if="imglist.length == 0" :after-read="onRead" accept="image/*" class="icon-add" ref="addPhone">
						<div class="addPhone"></div>
					</van-uploader>
				</div>
				<div class="tips">形象照片，建议图片尺寸: 690px*453px</div>
			</div>
			<div class="item">
				<div class="item_l">姓名：</div>
				<div class="item_r">
					<van-field v-model="name" placeholder="请输入姓名" />
				</div>
			</div>
			<div class="item">
				<div class="item_l">电话：</div>
				<div class="item_r">
					<van-field v-model="phone" placeholder="请输入手机号" />
				</div>
			</div>
			<div class="item">
				<div class="item_l">简介：</div>
				<div class="item_r">
					<van-field v-model="describe" type="textarea" placeholder="个人简介，字数在100字以内" maxlength="100" show-word-limit />
				</div>
			</div>
			<div class="item block">
				<div class="item_l">作品：<span class="tips">可以添加多个作品照片</span></div>
				<div class="item_r">
					<div class="upload-images">
						<div class="img-box" v-for="(item, index) in workslist" :key="index">
							<div class="icon-po">
								<van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
							</div>
							<div class="del" @click="worksImgDel(index)"></div>
						</div>
						<van-uploader :after-read="onReadWorks" accept="image/*" multiple :max-count="9" class="icon-add" ref="addPhone">
							<div class="addPhone"></div>
						</van-uploader>
					</div>
				</div>
			</div>
			<div class="item">
				<div class="item_l">献礼发言：</div>
				<div class="item_r">
					<van-field v-model="content" type="textarea" placeholder="献礼发言，字数在40字以内" maxlength="40" show-word-limit />
				</div>
			</div>
			<div class="item diqu">
				<div class="item_l">省·市·县：</div>
				<div class="item_r">
					<van-field class="item" v-model="province" readonly right-icon="arrow-down" placeholder="请选择" @click="showProvince = true" />
					<van-field class="item" v-model="city" readonly right-icon="arrow-down" placeholder="请选择" @click="clickCity" />
					<van-field class="item" v-model="area" readonly right-icon="arrow-down" placeholder="请选择" @click="clickArea" />
					<!-- <van-field v-model="area" readonly right-icon="arrow-down" placeholder="请选择"  @click="areaPicker=true" /> -->
				</div>
			</div>
		</div>
		<!-- 提交 -->
		<div class="btnwrap">
			<div class="btn" @click="bindPublish">确认</div>
		</div>
	</div>
	<!-- <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup> -->
	<!-- 省份 -->
    <van-popup v-model="showProvince" position="bottom">
        <van-picker show-toolbar :columns="provinceList" value-key="areaname" @confirm="onConfirmProvince" @cancel="showProvince = false"/>
    </van-popup>
	<!-- 城市 -->
	<van-popup v-model="showCity" position="bottom">
        <van-picker show-toolbar :columns="cityList" value-key="areaname" @confirm="onConfirmCity" @cancel="showCity = false"/>
    </van-popup>
	<!-- 地区 -->
	<van-popup v-model="showArea" position="bottom">
        <van-picker show-toolbar :columns="areaList" value-key="areaname" @confirm="onConfirmArea" @cancel="showArea = false"/>
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "xianli-publish",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            imglist: [],
			workslist: [],
			name: null,
			phone: null,
			describe: null,
			content: null,
			areaPicker: false,
			areaList: null,
			area1: null,
			area2: null,
			area3: null,
			area: null,
			province: null,
			city: null,
			area: null,
			provinceList: null,
			cityList: null,
			areaList: null,
			showProvince: false,
			showCity: false,
			showArea: false,
			status: this.$route.query.status, // 当前用户的献礼状态 0未审核 -1未通过
			uuid: null // 当前用户的uuid 
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '发起献礼',
                    // hiddenBack: true
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    // notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.uuid = data.result.uuid
						if(this.status != null){
							this.getData()
						}
                    } else {
                        this.token = "";
						this.uuid = ""
                    }
                    
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.uuid = this.$store.getters.uuid
        }
		// 当前用户发布的献礼未通过时
		if(this.status != null){
			this.getData()
		}
		// 获取省市区列表
		this.getAreaList()
    },
    methods: {
		// 获取当前用户的献礼详情
		getData(){
			var that = this
			var params = {
				token: that.token,
				from_uuid: that.uuid
			}
			that.$api.xianli.detail(params).then(res=>{
				if(res.code == 200){
					// 信息
					var info = res.result
					that.name = info.name
					that.phone = info.phone
					that.describe = info.describe
					that.content = info.content
					that.imglist = [info.thumb]
					that.workslist = JSON.parse(info.works)
					that.province = info.area1.areaname
					that.city = info.area2.areaname
					that.area = info.area3.areaname
					that.area1 = info.area1.id
					that.area2 = info.area2.id
					that.area3 = info.area3.id
				}
			})
		},
		// 上传形象照
		onRead: function (file) {
            console.log("file",file);
			var that = this
			that.$api.index.uploadImage({
				imgFile: file.content
			}).then(res => {
				if (res.code == 200) {
					that.imglist.push(res.result.url);
					console.log('形象照',that.imglist)
				}
			});
        },
        // 删除形象照
        imgDel(index) {
			var that = this
            that.imglist.splice(index, 1);
			console.log('形象照',that.imglist)
		},
		// 上传作品图
		onReadWorks(file){
			var that = this
            if ($.isArray(file)) {
                for (var i in file) {
                    that.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            that.workslist.push(res.result.url);
                        }
                    });
                }
            } else {
                that.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        that.workslist.push(res.result.url);
                    }
                });
            }
			console.log('作品照',that.workslist)
		},
		// 删除作品图
		worksImgDel(index){
			var that = this
            that.workslist.splice(index, 1);
			console.log('作品照',that.workslist)
		},
		// 获取地区
		getAreaData() {
            var params = {}
            this.$api.address.areaList(params).then(res => {
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
					
                    this.areaList = area.areaList;
					console.log('地区=====',area.areaList)
                } else {
                    this.$toast(res.message)
                }
            })
        },
		// 城市弹层
		clickCity(){
			var that = this
			if(that.province){
				that.showCity = true
			}else{
				that.$toast('请先选择省份')
			}
		},
		// 地区弹层
		clickArea(){
			var that = this
			if(that.city){
				that.showArea = true
			}else{
				that.$toast('请先选择城市')
			}
		},
		// 选择省份
		onConfirmProvince(val){
			var that = this
			console.log('选择省份',val)
			that.province = val.areaname
			that.area1 = val.id
			that.showProvince = !that.showProvince
			// 调城市
			that.city = null
			that.area2 = null
			that.area = null
			that.area3 = null
			that.getAreaList(val.id,1)
		},
		// 选择城市
		onConfirmCity(val){
			var that = this
			console.log('选择城市',val)
			that.city = val.areaname
			that.area2 = val.id
			that.showCity = !that.showCity
			// 调地区
			that.area = null
			that.area3 = null
			that.getAreaList(val.id,2)
		},
		// 选择地区
		onConfirmArea(val){
			var that = this
			console.log('选择地区',val)
			that.area = val.areaname
			that.area3 = val.id
			that.showArea = !that.showArea
		},
		// 省市区
		getAreaList(areaid,type){
			var that = this
			console.log('id====',areaid)
			var params = {}
			if(areaid){
				params.areaid = areaid
			}
			that.$api.xianli.areaList(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					console.log('省市区',res.result)
					if(type == 2){
						// 地区
						that.areaList = list
					}else if(type == 1){
						// 城市
						that.cityList = list
					}else{
						// 省份
						that.provinceList = list
					}
				}
			})
		},
		// 发布
		bindPublish(){
			var that = this
			var params = {
				token: that.token
			}
			if(that.imglist.length == 0){
				that.$toast('请上传形象照')
				return
			}else{
				params.thumb = that.imglist[0]
			}
			if(that.name == '' || that.name == undefined || that.name == undefined){
				that.$toast('请填写姓名')
				return
			}else{
				params.name = that.name
			}
			if (!that.phone) {
                that.$toast('请输入手机号');
                return
            } else if (!(/^1[23456789]\d{9}$/.test(that.phone))) {
                that.$toast('请输入合法的手机号');
                return
            }else{
				params.phone = that.phone
			}

			if(that.describe == '' || that.describe == undefined || that.describe == undefined){
				that.$toast('请填写简介')
				return
			}else{
				params.describe = that.describe
			}
			if(that.workslist.length == 0){
				that.$toast('请上传作品照')
				return
			}else{
				params.works = JSON.stringify(that.workslist)
			}
			if(that.content == '' || that.content == undefined || that.content == undefined){
				that.$toast('请填写献礼发言')
				return
			}else{
				params.content = that.content
			}
			if(that.area1){
				params.area1 = that.area1
			}
			if(that.area2){
				params.area2 = that.area2
			}
			if(that.area3){
				params.area3 = that.area3
			}
			// console.log('发布献礼params',params)
			that.$api.xianli.postarticle(params).then(res=>{
				if(res.code == 200){
					// that.$toast('发布成功')
					var that = this
					if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
						var params = {
							'data': {
								'url': that.$publicData.clientUrl + '/xianli/detail?from_uuid='+this.uuid
								}
							}
						that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						that.$router.push({
							path: '/xianli/detail',
							query: {
								from_uuid: this.uuid
							}
						})
					}
					// if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
					// 	var params = {}
					// 	that.$bridge.callhandler('sdjy://public/back', params, (data) => {

					// 	})
					// } else {
					// 	that.$router.push('/xianli/index')
					// }
				}
			})
		},
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
